var CurrentUser = require ("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");

require("writing/responses/share_response.scss")

class ShareResponse extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			shareURL: null, imgURL: null, loading: false
		};
	}

	loadShareURL(openShareF, e) {
		$wr.nope(e)

		if ($wr.isSafari()) {
			var windowReference = window.open();
		}
		if (this.state.shareURL) {
			openShareF(windowReference);
		} else {
			this.setState({ loading: true });
			CurrentUser.api().getResponseLink(this.props.responseID, $wr.apiHandler(function(response) {
				this.setState({ shareURL: response.link,  imgURL: response.image_url,
					loading: false }, function() {
						openShareF(windowReference);
					});
			}.bind(this)));
		}
	}

	openFacebookShare(windowReference) {
		Mycroft.newEvent({ category: "Response", action: "social-share", label: "facebook" });
		var fbURL = `http://www.facebook.com/sharer/sharer.php?u=${ encodeURIComponent(this.state.shareURL) }`;
		if (typeof windowReference != "undefined") {
			windowReference.location = fbURL;
		} else {
			window.open(fbURL, "_blank");
		}
	}

	openTwitterShare(windowReference) {
		Mycroft.newEvent({ category: "Response", action: "social-share", label: "twitter" });
		var twURL = `http://twitter.com/share?text=${ encodeURIComponent(this.getShareText() + "#whooosreading") }&url=${ encodeURIComponent(this.state.shareURL) }`;
		if (typeof windowReference != "undefined") {
			windowReference.location = twURL;
		} else {
			window.open(twURL, "_blank");
		}
	}

	openPinterestShare(windowReference) {
		Mycroft.newEvent({ category: "Response", action: "social-share", label: "pinterest" });
		var pinterestURL = `//www.pinterest.com/pin/create/button/?url=${ encodeURIComponent(this.state.shareURL) }&media=${ encodeURIComponent(this.state.imgURL) }&description=${ encodeURIComponent(this.getShareText()) }`;
		if (typeof windowReference != "undefined") {
			windowReference.location = pinterestURL;
		} else {
			window.open(pinterestURL, "_blank");
		}
	}

	openLinkShare(windowReference) {
		Mycroft.newEvent({ category: "Response", action: "social-share", label: "link" });
		var rawURL = this.state.shareURL;
		if (typeof windowReference != "undefined") {
			windowReference.location = rawURL;
		} else {
			window.open(rawURL, "_blank");
		}
	}

	openEmailShare(windowReference) {
		Mycroft.newEvent({ category: "Response", action: "social-share", label: "email" });
		var mailtoLink = `mailto:?subject=Check out what my student did!&body=Hi,%0D%0A%0D%0A${ this.getShareText() }%0D%0A${ encodeURIComponent(this.state.shareURL) }`;
		if (typeof windowReference != "undefined") {
			windowReference.location = mailtoLink;
		} else {
			window.open(mailtoLink, "_blank");
		}
	}

	getShareText() {
		return `Check out this reading activity my student completed on Whooo's Reading:`;
	}

	render() {
		if (this.state.loading) {
			var shareContent = (
				<div>
					<Spinner placeholder={ true } scale={ 1 } />
				</div>);
		} else {
			var shareContent = (
				<div className="social">
					<a href="#" onClick={ this.loadShareURL.bind(this, this.openEmailShare) }>
						<img src={ require("social-media-icons/email.png") } />
					</a>
					<a href="#" onClick={ this.loadShareURL.bind(this, this.openFacebookShare) }>
						<img src={ require("social-media-icons/facebook.png") } />
					</a>
					<a href="#" onClick={ this.loadShareURL.bind(this, this.openTwitterShare) }>
						<img src={ require("social-media-icons/twitter.png") } />
					</a>
					<a href="#" onClick={ this.loadShareURL.bind(this, this.openPinterestShare) }>
						<img src={ require("social-media-icons/pinterest.png") } />
					</a>
					<a href="#" onClick={ this.loadShareURL.bind(this, this.openLinkShare) }>
						<img src={ require("social-media-icons/link.png") } />
					</a>
				</div>
			);
		}

		return (
			<div className="shareResponse" ref="wrap">
				{ shareContent }
			</div>
		);
	}

	componentDidMount() {
		var $wrap = $(this.refs.wrap);
		var $modal = $wrap.closest(".modal");

		if ($modal.length > 0) {
			$modal.on("scroll", function() {
				var offsetY = $modal.scrollTop();
				$wrap.css("margin-top", offsetY);
			}.bind(this));
		}
	}
};

ShareResponse.propTypes = StrictPropTypes({
	responseID: PropTypes.number.isRequired
});

module.exports = ShareResponse;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/ShareResponse.js